import React from 'react'
import Products from '../../Component/Products'

const Category = () => {
  return (
    <div>
        <Products />
    </div>
  )
}

export default Category